import { DesignProp, LayoutProp } from "../PropCategories";

export const flexDirection = {
  prop: "style-attribute",
  name: "Direction",
  nameI18n: "builder_ui.prop_type.styles.item_direction",
  category: [DesignProp, LayoutProp],
  type: "select",
  defaultValue: "row",
  options: [
    {
      label: "Horizontal",
      labelI18n: "builder_ui.prop_type.styles.item_direction_types.horizontal",
      value: "row",
    },
    {
      label: "Vertical",
      labelI18n: "builder_ui.prop_type.styles.item_direction_types.vertical",
      value: "column",
    },
    {
      label: "Horizontal reversed",
      labelI18n:
        "builder_ui.prop_type.styles.item_direction_types.horizontal_reverse",
      value: "row-reverse",
    },
    {
      label: "Vertical reversed",
      labelI18n:
        "builder_ui.prop_type.styles.item_direction_types.column_reverse",
      value: "column-reverse",
    },
  ],
} as const;
